import axios from '@/plugins/axios';

const MESSAGE = '/message';

export async function updateBid(payload) {
  try {
    const { data } = await axios.post(`${MESSAGE}/bid-success`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function carryForward(payload) {
  try {
    const { data } = await axios.post(`${MESSAGE}/carry-forward`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function carryForwardReject(payload) {
  try {
    const { data } = await axios.post(`${MESSAGE}/carry-forward-reject`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function uploadImage(file) {
  try {
    const { data } = await axios.post(`${MESSAGE}/upload-image`, file);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function sendMail(payload) {
  try {
    const { data } = await axios.post(`${MESSAGE}/send-mail`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getItemValue() {
  try {
    const { data } = await axios.get(`${MESSAGE}/item-value`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getUserInfo(dataUser) {
  try {
    const { data } = await axios.get(`${MESSAGE}/user-info`, { params: dataUser });

    return data;
  } catch (error) {
    return { error };
  }
}

export async function checkWonBid(payload) {
  try {
    const { data } = await axios.get(`${MESSAGE}/check-won-bid`, { params: payload });

    return data;
  } catch (error) {
    return { error };
  }
}
